import axios from "axios";
import {getAdminToken, getSessionId, getUserToken, removeAdminToken, removeUserToken} from "@/store/session";
import router from "@/router";
import {ElMessage} from "element-plus";

// 设置默认配置
axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] = "application/json";

// 是否正在处理401错误，避免多次弹窗和跳转
let isHandlingUnauthorized = false;

// HTTP 请求拦截器
axios.interceptors.request.use(
    (config) => {
        config.headers["Chat-Token"] = getSessionId() || "";
        config.headers["Authorization"] = getUserToken() || "";
        config.headers["Admin-Authorization"] = getAdminToken() || "";
        return config;
    },
    (error) => Promise.reject(error)
);

// HTTP 响应拦截器
axios.interceptors.response.use(
    (response) => {
        const {data} = response;
        if (data.code === 0) {
            return response;
        } else {
            return Promise.reject(data);
        }
    },
    (error) => {
        const {response, config, code} = error;
        if (code === "ERR_NETWORK") {
            return Promise.reject(`网络异常，请稍后重试`);
        }
        if (response) {
            switch (response.status) {
                case 401:
                    handleUnauthorizedError(config.url);
                    break;
            }
        } else {
            ElMessage.error("服务异常，请稍后重试");
        }
        return Promise.reject(error); // 其他错误仍然 reject
    }
);

// 处理401错误
function handleUnauthorizedError(url) {
    if (isHandlingUnauthorized) return;
    isHandlingUnauthorized = true;

    const isAdminPath = url.includes("/admin");
    (isAdminPath ? removeAdminToken() : removeUserToken());
    const targetPath = isAdminPath ? "/pcadmin/login" : "/login";

    router.push(targetPath).finally(() => {
        isHandlingUnauthorized = false;
    });
}

// 通用请求函数
function httpRequest(method, url, data = {}, options = {}) {
    return axios({
        method,
        url,
        data,
        params: method === "get" ? data : undefined,
        ...options,
    })
        .then((response) => response.data)
        .catch((error) => {
            // 如果是 401，说明已经在拦截器中处理过了，直接返回
            if (error?.response?.status === 401) {
                return Promise.resolve(null);
            }
            // 其他错误继续抛出
            return Promise.reject(error);
        });
}


// GET 请求
export function httpGet(url, params = {}) {
    return httpRequest("get", url, params);
}

// POST 请求
export function httpPost(url, data = {}, options = {}) {
    return httpRequest("post", url, data, options);
}

// PUT 请求
export function httpPut(url, data = {}, options = {}) {
    return httpRequest("put", url, data, options);
}

// DELETE 请求
export function httpDelete(url, data = {}, options = {}) {
    return httpRequest("delete", url, data, options);
}
